import { Component, EventEmitter, Input, Output, HostListener, ElementRef } from '@angular/core';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrl: './filter.component.sass'
})
export class FilterComponent {
  @Input() uniqueServices: string[] = [];
  @Input() selectedServices: { [service: string]: boolean } = {};
  @Input() selectedStatuses: { [status: string]: boolean } = {};
  searchText: string = '';
  showFilter: boolean = false;

  @Output() searchTextChanged = new EventEmitter<string>();
  @Output() selectedServicesChanged = new EventEmitter<{ [service: string]: boolean }>();
  @Output() selectedStatusesChanged = new EventEmitter<{ [status: string]: boolean }>();
  
  @Output() filterChanged = new EventEmitter<void>();

  constructor(private elementRef: ElementRef) {}

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    if (!clickedInside && this.showFilter) {
      this.showFilter = false;
    }
  }

  toggleFilterVisibility(): void {
    this.showFilter = !this.showFilter;
  }
  toggleServiceSelection(service: string): void {
    this.selectedServices[service] = !this.selectedServices[service];
    this.filterChanged.emit();
  }

  toggleStatusSelection(status: string): void {
    this.selectedStatuses[status] = !this.selectedStatuses[status];
    this.filterChanged.emit();
  }
  clearServiceFilter(): void {
    this.selectedServices = {};
    this.selectedServicesChanged.emit(this.selectedServices);
  }
  clearStatusFilter(): void {
    this.selectedStatuses = {
      '申請済み': false,
      '未完了': false,
      '完了': false
    };
    this.selectedStatusesChanged.emit(this.selectedStatuses);
  }
  onSearchTextChange(): void {
    this.searchTextChanged.emit(this.searchText);
  }

  clearAllFilters(): void {
    this.searchText = '';
    this.selectedServices = {};
    this.selectedStatuses = {
      '申請済み': false,
      '未完了': false,
      '完了': false
    };
    this.searchTextChanged.emit(this.searchText);
    this.selectedServicesChanged.emit(this.selectedServices);
    this.selectedStatusesChanged.emit(this.selectedStatuses);
    this.filterChanged.emit();
  }
}

